import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'
import { SproutMark } from '@/components/brand/Logo'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { session, loading, isAdmin, clientId } = useAuthStore()
  const location = useLocation()

  if (loading) {
    return (
      <div className="loading-screen">
        <SproutMark size={64} className="loading-screen__mark" />
        <div className="loading-screen__wordmark">Go<span>grov</span></div>
      </div>
    )
  }

  if (!session) return <Navigate to="/login" replace />

  // Admin with no client of their own → send to admin dashboard (only if not already there)
  if (isAdmin && !clientId && !location.pathname.startsWith('/admin')) {
    return <Navigate to="/admin" replace />
  }

  return <>{children}</>
}
